import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useFetchChatList = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await get("chat/list?searchFilter=" + data.searchFilter);
    }, options);
};

export const useGetChatDetail = (options?: UseMutationOptions<any, any, { travellerId: string, agentId: string, adminId: string }, any>) => {
    return useMutation(
        async ({ travellerId, agentId, adminId }: { travellerId: string, agentId?: string, adminId: string  }) => {
            return await get("chat/detail?travellerId=" + travellerId + "&agentId=" + agentId + "&adminId=" + adminId);
        },
        options
    );
};

export const useGetTripListForNewChat = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(
        async(data: any) => {
            return await get("chat/triplist-newchat?searchFilter=" + data.searchFilter);
        },
        options
    )
}